import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=d1215470&scoped=true&"
var script = {}
import style0 from "./BackButton.vue?vue&type=style&index=0&id=d1215470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1215470",
  null
  
)

export default component.exports